import { IRequestDetails } from '../common';
import { pathOr } from 'rambda';
import { find as lfind, compose as lcompose, getOr as lgetOr } from 'lodash/fp';

export const justificationOptions = {
  ENROLL: [],
  RENEWAL: [],
  REVOKE: [
    // { value: '', label: '(Empty)' },
    { value: 'Affiliation Change', label: 'Affiliation Change' },
    { value: 'CA Compromise', label: 'CA Compromise' },
    { value: 'Cessation of Operation', label: 'Cessation of Operation' },
    { value: 'Key Compromise', label: 'Key Compromise' },
    { value: 'Superseded', label: 'Superseded' },
    { value: 'Other', label: 'Other' },
  ],
  DI_REVOKE: [
    { value: 'Affiliation Change', label: 'Affiliation Change' },
    { value: 'CA Compromise', label: 'CA Compromise' },
    { value: 'Cessation of Operation', label: 'Cessation of Operation' },
    { value: 'Key Compromise', label: 'Key Compromise' },
    { value: 'Superseded', label: 'Superseded' },
    { value: 'Immediate Suspension', label: '(ISO) Immediate Suspension' },
    { value: 'Admin Hearing', label: 'Admin Hearing' },
    { value: 'Civil Fine', label: 'Civil Fine' },
    { value: 'Compromised DEA No.', label: 'Compromised DEA No.' },
    { value: 'Cyclical Investigation', label: 'Cyclical Investigation' },
    { value: 'DEA6 Complete', label: 'DEA6 Complete' },
    { value: 'Denial for Renewal', label: 'Denial for Renewal' },
    { value: 'Denied', label: 'Denied' },
    { value: 'HQ Drug Code Added', label: 'HQ Drug Code Added' },
    { value: 'Letter of Admonition', label: 'Letter of Admonition' },
    { value: 'MOA', label: 'MOA' },
    { value: 'Monthly Retire', label: 'Monthly Retire' },
    { value: 'Online Pharmacy DEA6', label: 'Online Pharmacy DEA6' },
    { value: 'Online Pharmacy Denial', label: 'Online Pharmacy Denial' },
    { value: 'Online Pharmacy Withdrawal', label: 'Online Pharmacy Withdrawal' },
    { value: 'OTSC Requested to CC', label: 'OTSC Requested to CC' },
    { value: 'OTSC Signed by DC', label: 'OTSC Signed by DC' },
    { value: 'Out of Business', label: 'Out of Business' },
    { value: 'Protocol Change', label: 'Protocol Change' },
    { value: 'Retire in Lieu of OTSC', label: 'Retire in Lieu of OTSC' },
    { value: 'Revoked', label: 'Revoked' },
    { value: 'SSA-DMF', label: 'SSA-DMF' },
    { value: 'Surrender for Cause', label: 'Surrender for Cause' },
    { value: 'Temporary Suspension', label: 'Temporary Suspension' },
    { value: 'Under Investigation', label: 'Under Investigation' },
    { value: 'Under Review', label: 'Under Review' },
    { value: 'Withdrawn', label: 'Withdrawn' },
    { value: 'Withdrawn for Good Cause', label: 'Withdrawn for Good Cause' },
    { value: 'Withdrawn in Lieu of OTSC', label: 'Withdrawn in Lieu of OTSC' },
    { value: 'Other', label: 'Other' },

  ],
};

export const requestorComments =
  (reqType: 'ENROLL' | 'RENEWAL' | 'REVOKE') =>
  (previousRequest: IRequestDetails | undefined) =>
    pathOr(null, 'reqType')(previousRequest) === reqType
      ? pathOr(null, 'requestorComments')(previousRequest)
      : null;

export const requestorCommentsOfRevoke = (value: string) =>
  lcompose(
    lgetOr('Other', 'value'),
    lfind<{ value: string; label: String }>({ value })
  )(justificationOptions.REVOKE);
